export default function BlogTitle( { data } ){
    let title = data.properties?.Name?.title[0]?.plain_text;
    let summary = data.properties?.Summary?.rich_text?.[0]?.plain_text;
    let date = data.properties?.Date.formula.string;
    let days = data.properties?.Days.formula.string;
    let tags = data.properties?.Tags.multi_select;
    let category = data.properties?.Category.multi_select;
    let link = data.properties?.Link?.rich_text?.[0]?.plain_text;

    let created = data.properties?.Created_date.formula.string;
    let edited = data.properties?.Edited_date.formula.string;

    let thumbnail = data.icon?.file?.url || null;

    let series = data.properties?.Series_rollup.rollup.array[0]?.title[0]?.plain_text || null;

    // console.log(data);
    
    return(
        <div style = { { marginBottom : "24px", position : "relative" } }>
            
            <h1 className = "heading" style = { { fontSize : "64px", color : "var(--black88)", lineHeight : "100%" }}>{ title }</h1>
            <p className = "heading" style = { { fontSize : "16px", color : "var(--black40)", lineHeight : "120%", fontWeight : "500" }}>{ summary }</p>
            {/* <p className = "meta2" style = { { marginTop : "40px" } }>Created { created }</p>
            <p className = "meta2" style = { { marginTop : "8px" } }>Edited { edited }</p> */}
        
      </div>
    )
}